import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { NumericalInput } from '../../shared';

import {
  formatThousands,
  localize,
  getCurrentMonthCountInQuarter,
} from '../../../util';

class ForecastGoal extends Component {

  getGoalProps(){
    const { isCustom, goalTarget, goalTargets, frequency } = this.props.goal;

    const goalIsMonthly = frequency === 'monthly';

    const sprintEndDateToUseForGoal = this.props.anticipatedSubmissionDate || this.props.endDate || undefined;

    // console.log('sprintEndDateToUseForGoal: ', sprintEndDateToUseForGoal);

    const currentMonthCount = getCurrentMonthCountInQuarter(this.props.organizationData.quarterOneStartMonthOffset, sprintEndDateToUseForGoal);
    const dateToAssignMonthFor = moment(sprintEndDateToUseForGoal);

    // console.log('currentMonthCount: ', currentMonthCount);

    const goalTargetToDisplay = goalTarget ? goalTarget : goalTargets[currentMonthCount];

    if(goalIsMonthly){
      //monthly

      return {
        status: 'blank',
        text: `${dateToAssignMonthFor.format('MMM')} Goal: ${formatThousands(goalTargetToDisplay || '')}`,
      }
    }
    else{
      //quarterly

      return {
        status: 'blank',
        text: `Goal: ${formatThousands(goalTargetToDisplay || '')}`,
      }
    }
  }

  handleMetaUpdate(propName, newValue){
    this.props.updateMeta({
      [propName]: newValue
    });
  }

  renderStandardGoalItems(){
    const { localizations, organizationData } = this.props;
    const { goalValue, goalMeta } = this.props.goal;
    const bestCasePrediction = goalMeta && goalMeta.bestCasePrediction ? goalMeta.bestCasePrediction : '';
    const worstCasePrediction = goalMeta && goalMeta.worstCasePrediction ? goalMeta.worstCasePrediction : '';

    const forecastRangeEnabled = !organizationData.forecastingRangeDisabled;

    return (
      <React.Fragment>
        <NumericalInput className="fs-block" disabled={!this.props.editable} formatThousands={true} value={goalValue} onUpdate={this.props.update} />
        <label>{localize('outcome_best_prediction', localizations)}</label>

        {forecastRangeEnabled &&
          <React.Fragment>
            <div className="divider"></div>
            <div className="input-group" style={{float: 'right'}}>
              <label>{localize('outcome_range_label', localizations)}</label>
              <NumericalInput className="fs-block" placeholder={localize('outcome_low_prediction', localizations)} disabled={!this.props.editable} formatThousands={true} value={worstCasePrediction} onUpdate={val => { this.handleMetaUpdate('worstCasePrediction', val); }} />
              <label className="range-label">&mdash;</label>
              <NumericalInput className="fs-block" placeholder={localize('outcome_high_prediction', localizations)} disabled={!this.props.editable} formatThousands={true} value={bestCasePrediction} onUpdate={val => { this.handleMetaUpdate('bestCasePrediction', val); }} />
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }

  updateValueForCustomGoalItem(item, newValue){
    this.props.updateCustomGoalValues({
      [item]: newValue
    });
  }

  renderCustomGoalItems(){
    const { customGoalValues, items } = this.props.goal;

    return (
      <React.Fragment>
        <div className="divider"></div>
        {_.map(items, item => {

          const valueForItem = (customGoalValues || {})[item] || '';

          return (
            <React.Fragment key={`item-${item}`}>
              <NumericalInput className="fs-block" disabled={!this.props.editable} formatThousands={true} value={valueForItem} onUpdate={newValue => { this.updateValueForCustomGoalItem(item, newValue); }} />
              <label>{item}</label>
            </React.Fragment>
          )
        })}
      </React.Fragment>
    );
  }

  render(){
    const { name, description, goalMeta, isCustom } = this.props.goal;

    const editableClass = this.props.editable ? 'editable' : '';

    const goalProps = this.getGoalProps();

    return (
      <div className={`goal forecast blank ${editableClass}`}>
        <div className="description">{goalMeta && goalMeta.customDescription ? goalMeta.customDescription : (description && description !== '' ? description : name)}</div>
        <div className={'input-goal fs-block'}>{formatThousands(goalProps.text)}</div>

        {!isCustom && this.renderStandardGoalItems()}
        {isCustom && this.renderCustomGoalItems()}
      </div>
    );
  }
}

function mapStateToProps(state){
  return {
    organizationData: state.organization.data || {},
  }
}

export default connect(mapStateToProps, {})(ForecastGoal);



// WEBPACK FOOTER //
// ./src/components/sprint/goalTemplates/forecastGoal.js